import type { ReactNode } from 'react';
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { WarningModal } from './WarningModal.tsx';

export const i18n: {
	fileTooBig: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fileExceedsLimit: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	fileTooBig: {
		id: 'import-from-sources.warning-modal.fileTooBig',
		defaultMessage: 'This file is too big',
		description: "Message in modal header indicating that the file's size is bigger than the limit",
	},
	fileExceedsLimit: {
		id: 'import-from-sources.warning-modal.fileExceedsLimit',
		defaultMessage:
			'{fileName} is {fileSize} MB which exceeds the 100 MB limit. You could break the content into smaller files and import them separately.',
		description: "Message in modal body indicating that the file's size is bigger than the limit",
	},
});

export const FileSizeModal: React.FC<{
	onSubmit: () => void;
	onClose: () => void;
	fileData?: {
		fileName: string;
		fileSize: number;
	};
	bodyText?: ReactNode;
}> = ({ onSubmit, onClose, fileData, bodyText }) => {
	return (
		<WarningModal
			onSubmit={onSubmit}
			onClose={onClose}
			headText={<FormattedMessage {...i18n.fileTooBig} />}
			bodyText={
				bodyText || (
					<FormattedMessage
						{...i18n.fileExceedsLimit}
						values={{
							fileName: <b>{fileData?.fileName}</b>,
							fileSize: <b>{fileData?.fileSize}</b>,
						}}
					/>
				)
			}
		/>
	);
};
